import React from "react";
import _ from "i18n";
import { connect } from "react-redux";
import { fetchEvents, fetchSurveys, fetchEmailSettings, fetchEventCycles } from "thunks";
import Async from 'react-select/async';
import { BadgeOption } from "../../ui/select/CustomOption";
import { mapEventsData, mapSurveysData } from "utils";
import TTPSelect from "../../common/TTPSelect";
import { getSupportedAppsOptions } from "../../../services/apps";
import Application from "../../common/Application";
import {
  sortEventByStartDateTime,
  transformDateFormat,
  ucFirst,
} from "../../../services/common";

const mapStateToProps = (state) => ({
  lng: state.params.lng,
  currentSetting: state.genericEmail.currentSetting,
});

const mapDispatchToProps = dispatch => ({
  fetchSurveys: () => dispatch(fetchSurveys()),
  fetchEvents: (id) => dispatch(fetchEvents(id, true)),
  fetchEventCycles: (id) => dispatch(fetchEventCycles(id, true)),
  fetchCurrentSettings: filter => dispatch(fetchEmailSettings(filter)),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class TargetSelects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventsType: "future",
    };
    this.targetAppOptions = [
      { value: 'EVENT_REVIVAL', label: <Application name={'EVENT REVIVAL'} logo={"event"} />, id: 'EVENT_REVIVAL' },
      { value: 'EVENT_REMINDER', label: <Application name={'EVENT REMINDER'} logo={"event"} />, id: 'EVENT_REMINDER' },
      ...getSupportedAppsOptions().filter(app => {
        return ["EVENT", "PAYMENT"].indexOf(app.value) < 0;
      })
    ];
  }

  loadTargetsOptions = (inputValue, callback) => {
    const { fetchEvents, fetchSurveys, fetchEventCycles, lng, currentSetting: { targetApp } } = this.props;

    switch (targetApp) {
      case "EVENT":
        fetchEvents(inputValue).then((res) => {
          const options = this.mapDatedEventsData(res);
          callback(options);
        }).catch(() => callback([]));
        break;

      case "SURVEY":
        fetchSurveys(inputValue).then((res) => {
          const options = mapSurveysData(res, lng);
          callback(options);
        }).catch(() => callback([]));
        break;

      case "EVENT_CYCLE":
        fetchEventCycles(inputValue).then((res) => {
          const options = mapEventsData(res, lng);
          callback(options);
        }).catch(() => callback([]));
        break;

      default:
        callback([]);
        break;
    }
  };

  mapDatedEventsData = (res) => {
    const { lng } = this.props;
    const { eventsType } = this.state;
    const rawEvents = res?.value?.data?.data || [];
    const lngUc = ucFirst(lng);
    const sortedEvents = sortEventByStartDateTime(rawEvents, "DESC", eventsType);

    return sortedEvents.map((event) => {
      const languages = JSON.parse(event.languages || "{}") || {};
      const types = event.emailsTypes || [];
      const name =
        event[`name${lngUc}`] || event.nameFr || event.nameNl || event.nameEn;
      const date = event.startDateTime
        ? transformDateFormat(event.startDateTime)
        : null;

      return {
        label: date ? `${date} || ${name}` : name,
        id: event.id + "",
        fromNameFr: event.contactFr,
        fromNameEn: event.contactEn,
        fromNameNl: event.contactNl,
        fromEmailFr: event.emailContactFr,
        fromEmailEn: event.emailContactEn,
        fromEmailNl: event.emailContactNl,
        languages: Object.keys(languages)
          .filter((l) => languages[l] == "1")
          .map((l) => l.toLowerCase()),
        types,
        count: `${types.length} ${_("emails types")}`,
      };
    });
  };

  renderEventTypeToggle = () => {
    const { eventsType } = this.state;
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          fontWeight: "normal",
          fontSize: "14px",
        }}
      >
        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            marginLeft: "12px",
          }}
        >
          <input
            type="radio"
            name="target-event-type"
            style={{ margin: 0 }}
            checked={eventsType === "future"}
            onChange={() => this.setState({ eventsType: "future" })}
          />
          <span style={{ marginLeft: "5px" }}>{_("future")}</span>
        </label>
        <label
          style={{
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            marginLeft: "12px",
          }}
        >
          <input
            type="radio"
            name="target-event-type"
            style={{ margin: 0 }}
            checked={eventsType === "past"}
            onChange={() => this.setState({ eventsType: "past" })}
          />
          <span style={{ marginLeft: "5px" }}>{_("past")}</span>
        </label>
      </span>
    );
  };

  handleTargetChange = (target) => {
    const { activeLanguage, targetChanged, fetchCurrentSettings, currentSetting: { targetApp }, onStateChange } = this.props;
    targetChanged(target, targetApp);
    if (target && target.id) {
      fetchCurrentSettings({ targetApp, targetId: target.id });
    }

    if (target && target.languages && !target.languages.some(lng => lng === activeLanguage)) {
      onStateChange({ activeLanguage: target.languages[0] || null });
    }
  };

  render() {
    const { currentSetting: { targetApp, target, types }, lockTarget } = this.props;

    if (["SURVEY", "EVENT", "PAYMENT", "EVENT_CYCLE"].indexOf(targetApp) === -1) {
      return null;
    }

    let select = null;
    let app = targetApp.toLowerCase();
    if (lockTarget) {
      let typesCount = types?.length || 0 ;
      if (targetApp === "PAYMENT" && ["EVENT_REMINDER", "EVENT_REVIVAL"].indexOf(target.id) > -1){
        typesCount = types.filter(function (t) {
          if (target.id === "EVENT_REVIVAL") {
            return t.id.search("RELANCE") > -1
          } else {
            return t.id.search("RELANCE") < 0
          }
        }).length;
      }
      select = <div className="target-label">
        {_(target?.label)}
        <span>{typesCount} {_('emails types')}</span>
      </div>
    } else if (["EVENT", "SURVEY", "EVENT_CYCLE"].indexOf(targetApp) > -1) {
      select = <Async
        key={`${app}-${this.state.eventsType}`}
        inputId={`${app}-select`}
        cacheOptions
        defaultOptions
        className={`ttp-select ${!target && "empty-box"}`}
        classNamePrefix="ttp-select"
        placeholder={_(`Select`)}
        value={target}
        onChange={target => this.handleTargetChange(target)}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.label}
        loadOptions={this.loadTargetsOptions}
        components={{ Option: BadgeOption }}
        noOptionsMessage={() => _("Nothing Found")}
        loadingMessage={() => _("Loading suggestions ...")}
      />
    } else if ("PAYMENT" === targetApp) {
      select = <TTPSelect
        isObjects
        simple
        notClearable
        values={target?.id}
        placeholder={_('target')}
        options={this.targetAppOptions}
        onChange={this.handleTargetChange}
      />
    }

    return (
      <div className="field" key={`${app}-select-input`}>
        {!lockTarget && targetApp === "EVENT" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span className="param-label">{_(targetApp.toLowerCase())} </span>
            {this.renderEventTypeToggle()}
          </div>
        ) : (
          <span className="param-label">{_(targetApp && targetApp !== "PAYMENT" ? targetApp.toLowerCase() : 'target')} </span>
        )}
        {select}
      </div>
    )
  }
}
